import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { DTypeFormTextField } from '@grupo-constant/next-dtype/form';
import {
    ADDRESSBYGOOGLE_COLUMN_URI,
    CODEBARSCANNERWITHSELECT_URI,
    DATEPICKER_COLUMN_URI,
    DTypeCol, DTypeViewableCol, INTEGER_COLUMN_URI,
    LANGUAGETEXT_COLUMN_URI,
    RATING_COLUMN_URI,
    REAL_COLUMN_URI,
    SELECTFROMURI_COLUMN_URI,
    SELECTWITHGIVENOPTIONS_COLUMN_URI,
    TEXT_COLUMN_URI,
    TIMEPICKER_COLUMN_URI
} from '@grupo-constant/next-dtype/types';
import { Subject, takeUntil } from 'rxjs';
import { DTypeFormFieldComponent } from '../../dtype-field.model';
import { DTypeService } from '../../dtype.service';

@Component({
    selector: 'complex-mask-field-component',
    templateUrl: './complex-mask-field.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatChipsModule]
})
export class DtypeComplexMaskFieldComponent implements DTypeFormFieldComponent, OnInit, OnDestroy {

    @Input() field: DTypeFormTextField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;

    columns: DTypeCol[];
    validTypes = [
        TEXT_COLUMN_URI,
        LANGUAGETEXT_COLUMN_URI,
        INTEGER_COLUMN_URI,
        REAL_COLUMN_URI,
        DATEPICKER_COLUMN_URI,
        TIMEPICKER_COLUMN_URI,
        ADDRESSBYGOOGLE_COLUMN_URI,
        SELECTFROMURI_COLUMN_URI,
        SELECTWITHGIVENOPTIONS_COLUMN_URI,
        CODEBARSCANNERWITHSELECT_URI,
        RATING_COLUMN_URI
    ];

    private _unsubscribeAll = new Subject<void>();

    constructor(private dtypeService: DTypeService) { }

    ngOnInit() {
        const readonlyOnUpdate = (this.field.dTypeCol as DTypeViewableCol).readonlyOnUpdate;
        if (readonlyOnUpdate && this.isUpdate) {
            this.field.readonly = true;
        }

        this.dtypeService.tableComponentColumns$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((columns) => {
                this.columns = columns.filter(c => this.columnIsValid(c));
            });
    }

    ngOnDestroy() {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    add(column: DTypeCol) {
        const str = this.field.control.value ?? '';
        this.field.control.setValue(str + '{{' + column.name + '}}');
    }

    private columnIsValid(column: DTypeCol) {
        return this.validTypes.includes(column.type);
    }

}
